
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M22 11.82v.38a.767.767 0 01-.22.529l-4.14 4.12a.5.5 0 01-.71.001l-.71-.709a.489.489 0 010-.699l3.45-3.432-3.45-3.432a.5.5 0 010-.709l.71-.698a.5.5 0 01.71 0l4.14 4.12c.14.141.22.331.22.53zm-17.67.19l3.44-3.432a.49.49 0 000-.699l-.71-.708a.5.5 0 00-.71 0l-4.13 4.12a.77.77 0 00-.22.53v.379c0 .198.08.388.22.529l4.14 4.12a.5.5 0 00.71.001l.71-.699a.495.495 0 000-.708L4.33 12.01zm11-7.613l-.97-.37a.521.521 0 00-.65.3L8.4 18.995a.499.499 0 00.3.639l.94.339a.51.51 0 00.64-.3l5.31-14.648a.498.498 0 00-.3-.628h.04z"}})])
          )
        }
      }
    